if (!customElements.get('tribe-review-slider')) {
  customElements.define('tribe-review-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.slides = [...this.querySelectorAll('[data-review]')];
      if (this.slides.length < 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.index = 0;
      this.paused = this.dataset.autoplay !== 'true';
      this.hovered = false;
      this.inView = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.interval = Math.max(5000, Number(this.dataset.interval) || 6000);
      this.track = this.querySelector('[data-review-track]');
      this.counter = this.querySelector('[data-review-current]');
      this.toggle = this.querySelector('[data-review-toggle]');
      this.classList.add('is-enhanced');
      this.querySelector('[data-review-controls]').hidden = false;
      this.querySelector('[data-review-previous]').addEventListener('click', () => this.move(-1), options);
      this.querySelector('[data-review-next]').addEventListener('click', () => this.move(1), options);
      this.toggle?.addEventListener('click', () => { this.paused = !this.paused; this.updateRotation(); }, options);
      this.addEventListener('focusin', (event) => {
        if (event.target === this.toggle) return;
        this.paused = true;
        this.updateRotation();
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.updateRotation(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.updateRotation(); }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      document.addEventListener('visibilitychange', () => this.updateRotation(), options);
      document.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('[data-review]');
        if (!slide || !this.contains(slide)) return;
        this.paused = true;
        this.show(this.slides.indexOf(slide));
        this.updateRotation();
      }, options);
      this.motion.addEventListener('change', () => this.updateRotation(), options);
      this.observer = new IntersectionObserver((entries) => {
        this.inView = entries.some((entry) => entry.isIntersecting);
        this.updateRotation();
      });
      this.observer.observe(this);
      this.show(0);
      this.updateRotation();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, current) => { const inactive = current !== this.index; slide.hidden = inactive; slide.inert = inactive; });
      this.counter.textContent = String(this.index + 1);
    }
    move(direction) { this.paused = true; this.show(this.index + direction); this.updateRotation(); }
    updateRotation() {
      clearInterval(this.timer);
      const canRotate = !this.paused && !this.hovered && this.inView && !document.hidden && !this.motion.matches;
      this.track.setAttribute('aria-live', canRotate ? 'off' : 'polite');
      if (this.toggle) {
        this.toggle.hidden = this.motion.matches;
        this.toggle.classList.toggle('is-paused', this.paused);
        this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
      }
      if (canRotate) this.timer = setInterval(() => this.show(this.index + 1), this.interval);
    }
    disconnectedCallback() { clearInterval(this.timer); this.controller?.abort(); this.observer?.disconnect(); this.controller = null; }
  });
}
